module.exports = __webpack_public_path__ + "static/media/cupcakeCarrot.63055d48.jpg";